var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_vm._v(" Limit chargers by network ")]),_c('v-card-actions',[_c('v-btn',{staticClass:"text-none rounded-lg",attrs:{"color":"primary"},on:{"click":_vm.openNetworkSettings}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v(" mdi-cog ")]),_vm._v(" Network Settings ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }